import { styled } from '@mui/material/styles';
import { Button } from 'components/buttons';

export const Text = styled('p')(({ theme, color }) => ({
  color: color || theme.color.primary.main,
  fontSize: theme.fontSize.small,
  margin: '5px 0'
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  '&:disabled, &[disabled], &[aria-disabled="true"], &[data-disabled="true"]': {
    cursor: 'default',
    pointerEvents: 'none',
    backgroundColor: theme.color.disabled.background,
    color: theme.color.disabled.text,
    '&:hover, &:active': {
      backgroundColor: theme.color.disabled.background,
      color: theme.color.disabled.text
    }
  }
}));
